import { get } from '@/utils/http-helper';
import router from '@/router';

const GET = '/workshop/get';
const GET_REVIEW = '/review/get';

export default {
    namespaced: true,
    state: {
        workshop: null,
    },
    actions: {
        async get({ commit }, topicId) {
            // Drop the previous topic before the request goes out. Opening a
            // topic, returning to the agenda and opening another one left this
            // state populated, so the old topic rendered until the new response
            // arrived — and then merged with it.
            commit('clearWorkshop');

            const workshop = await get(GET, {
                topic_id: topicId,
                event_id: router.app._route.query.event_id,
            });
            if (workshop.status) {
                commit('setWorkshop', workshop.data);
            }
        },
        async getReview({ commit }, topicId) {
            commit('clearWorkshop');

            const workshop = await get(GET_REVIEW, {
                topic_id: topicId,
                event_id: router.app._route.query.event_id,
                question_id: router.app._route.query.question_id || 0,
            });
            if (workshop.status) {
                commit('setWorkshop', workshop.data);
            }
        },
        async getPage({ commit }, { topicId, question_id, page, path }) {
            const workshop = await get(path, {
                topic_id: topicId,
                question_id,
                page,
                event_id: router.app._route.query.event_id,
            });
            if (workshop.status) {
                commit('updateWorkshop', workshop.data);
            }
        },
    },

    mutations: {
        // Merge — used by getPage, which fetches more of the SAME topic and
        // must keep what is already loaded.
        updateWorkshop(state, workshop) {
            if (state.workshop) {
                state.workshop = { ...state.workshop, ...workshop };
            } else {
                state.workshop = workshop;
            }
        },

        // Replace — used when loading a DIFFERENT topic. Merging there carried
        // any key the new topic happened to omit over from the previous one.
        setWorkshop(state, workshop) {
            state.workshop = workshop;
        },

        clearWorkshop(state) {
            state.workshop = null;
        },
    },

    getters: {
        get: state => state.workshop,
    },
};
